import React, { useState, useEffect, useCallback, useMemo } from "react";
import Select from "react-select";
import SubmitButton from "../../components/Common/buttons/SubmitButton";
import { NavLink } from "react-router-dom";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import TableMain from "../../components/Common/table/TableMain";
import OtherWalletTiles from "../../components/Ggwallet/OtherWalletTiles";

const RealWalletLayout = () => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectStatement, setSelectedStatement] = useState(true);
  const [selectedProjectValue, setSelectedProjectValue] = useState([]);
  const [project, setProject] = useState([]);

  const ewallet = ApiHook.CallRealwalletTiles();
  const statement = ApiHook.CallRealwalletStatement(
    currentPage,
    itemsPerPage,
    selectStatement,
    project,
    setSelectedStatement
  );

  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector((state) => state?.user?.conversionFactor);

  // Memoize project options to avoid redundant calculations
  const Options = useMemo(() => {
    return (
      statement?.data?.projects?.map((item) => ({
        label: t(item.label),
        value: item.value,
      })) || []
    );
  }, [statement?.data?.projects, t]);

  // Handle project selection
  const handleProjectSelectChange = useCallback((values) => {
    const selectedValues = values.map((value) => value.value);
    setProject(selectedValues);
    setSelectedProjectValue(values);
  }, []);

  // Handle tab change actions
  const handleTabChange = useCallback((e) => {
    if (e.target.id === "searchButton") {
      setSelectedStatement(true);
    } else if (e.target.id === "resetButton") {
      setProject([]);
      setSelectedProjectValue([]);
      setSelectedStatement(true);
    }
  }, []);

  const headers = useMemo(
    () => [
      t("description"),
      t("amount"),
      t("transaction_date"),
      t("balance"),
    ],
    [t]
  );

  return (
    <>
      <div className="page_head_top">Real Estate Wallet</div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-md-4">
            <NavLink to="/e-wallet" className="btn_ewallt_page">
              {t("ewallet")}
            </NavLink>
            <NavLink className="btn_ewallt_page" activeclassname="active">
              Real Estate Wallet
            </NavLink>
            <NavLink to="/gg-wallet" className="btn_ewallt_page">
              GGFC Wallet
            </NavLink>
            <NavLink to="/lottery-wallet" className="btn_ewallt_page">
              Game Wallet
            </NavLink>
          </div>
        </div>
      </div>
      <OtherWalletTiles
        tiles={ewallet?.data}
        currency={userSelectedCurrency}
        conversionFactor={conversionFactor}
      />
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="ewallet_table_section_cnt_tab_head">
            <NavLink className="ewallet_tab_btn active">{t("statement")}</NavLink>
          </div>
        </div>
        <div className="table-responsive min-hieght-table">
          <div className="filter_Section">
            <div className="row">
              <div className="col-xl-3 col-md-3">
                <div className="right_search_div">
                  <label className="la-control">{t("Projects")}</label>
                  <Select
                    options={Options}
                    value={selectedProjectValue}
                    onChange={handleProjectSelectChange}
                    isMulti
                  />
                </div>
              </div>
              <div className="col-xl-2 col-md-3 mt-4">
                <div className="right_search_div d-flex gap-1">
                  <SubmitButton
                    isSubmitting=""
                    text="Search"
                    className="btn btn-primary"
                    click={handleTabChange}
                    id="searchButton"
                  />
                  <SubmitButton
                    isSubmitting=""
                    text="Reset"
                    className="btn btn-secondary"
                    click={handleTabChange}
                    id="resetButton"
                  />
                </div>
              </div>
            </div>
          </div>
          <TableMain
            headers={headers}
            data={statement?.data?.data || []}
            startPage={1}
            currentPage={statement?.data?.currentPage || 1}
            totalPages={statement?.data?.totalPages || 1}
            setCurrentPage={setCurrentPage}
            type="ewallet"
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            activeTab={setSelectedStatement}
            setApiTab={setSelectedStatement}
          />
        </div>
      </div>
    </>
  );
};

export default RealWalletLayout;
